import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm) => boolean;
}

export const isFieldsRequiredForProfVisitStatusTypeCompleted = (
  fieldName: string | undefined,
  values: IKnmForm,
): boolean => {
  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForProfVisitStatusTypeCompleted[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForProfVisitStatusTypeCompleted[fieldNameTemplate];

  return !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values);
};

const fieldsRequiredForProfVisitStatusTypeCompleted: Record<string, IMarkedField> = {
  subjectNotifications: {
    appendShowMarkCondition: values => !values.subjectNotifications || values.subjectNotifications.length === 0,
  },
  act: {
    appendShowMarkCondition: values => !values.act,
  },
};
